import { Outlet } from "react-router-dom";
import { useEffect} from "react";
import "../Layouts/Layout.scss";

const Default_pg = (props) => {
  useEffect(() => {
    document.title= props.title;
  }, [props.title]);

  return (
    <>
      {/* <div id="" className="page-content-container">
        <h1>{props.title}</h1> */}
        <Outlet />
      {/* </div> */}
    </>
  );
};
export default Default_pg;
